export const HOME = "home";
export const ABOUT = "about";
export const LOGIN = "login";
export const DASHBOARD = "dashboard";

// User
const user = "user";
export const USER = {
  ROOT: `${user}`,
  BROWSE: `${user}.browse`,
  REGISTERING_EXTERNAL: `${user}.registering.external`,
  UPDATE: `${user}.update`,
  REPORTING: `${user}.reporting`,
  DETAIL: `${user}.detail`
};

// PO Status
const po_status = "postatus";
export const PO_STATUS = {
  ROOT: `${po_status}`,
  BROWSE: `${po_status}.browse`,
  DETAIL: `${po_status}.detail`,
  SALES: `${po_status}.sales`,
  DETAIL_SALES: `${po_status}.sales-detail`,
  PHOTOS_POOLING: `${po_status}.photos-screening`,
  ARCHIVE: {
    BROWSE: `${po_status}.archive`,
    DETAIL: `${po_status}.archive-detail`
  }
};

// Profile
const profile = "profile";
export const PROFILE = {
  ROOT: `${profile}`,
  DETAIL: `${profile}.detail`,
  UPDATE: `${profile}.update`,
  CHANGE_PASSWORD: `${profile}.change.password`
};

// Roles
const roles = "roles";
export const ROLES = {
  ROOT: `${roles}`,
  LIST: `${roles}.list`,
  CREATE: `${roles}.create`,
  UPDATE: `${roles}.update`,
  DETAIL: `${roles}.detail`,
  RESTRICTION_EXPORT: {
    UPDATE: `${roles}.restriction.update`
  }
};

// Card Distribution
const card_distribution = "card.distribution";
export const CARD_DISTRIBUTION = {
  ROOT: `${card_distribution}`,
  LIST: `${card_distribution}.list`,
  REPORTING: `${card_distribution}.reporting`,
  ASSIGNMENT: {
    LIST: `${card_distribution}.assign`,
    DETAIL: `${card_distribution}.assign.detail`,
    CREATE: `${card_distribution}.assign.create`,
    CARD_LIST: {
      DETAIL: `${card_distribution}.assign.cardlist.detail`
    },
    SEARCH: {
      RESULT: `${card_distribution}.assign.search`
    }
  },
  PICK_UP: {
    LIST: `${card_distribution}.pickup`,
    CREATE: `${card_distribution}.create`,
    DETAIL: `${card_distribution}.detail`
  }
};

// Card Verification
const card_verification = "card.distribution.verif";
export const CARD_VERIFICATION = {
  ROOT: `${card_verification}`,
  DETAIL: {
    ROOT: `${card_verification}.detail`,
    MANUAL_CHECK: `${card_verification}.manual.check`
  }
};

// Card Stock
const card_stock = "card.distribution.stock";
export const CARD_STOCK = {
  ROOT: `${card_stock}`,
  DETAIL: {
    BRANCH: `${card_stock}.detail.branch`,
    MRA: `${card_stock}.detail.mra`
  }
};

// Card No Generator Setup
const card_generator = "card.nogenerator";
export const CARD_GENERATOR = {
  ROOT: `${card_generator}`,
  SETUP: `${card_generator}.setup`,
  DELIVER: {
    TO_BRANCH: `${card_generator}.branch`,
    TO_CUSTOMER: `${card_generator}.customer`
  }
};

// Card No Reservations
const card_reservations = "card.noreserv";
export const CARD_RESERVATIONS = {
  ROOT: `${card_reservations}`,
  LIST: `${card_reservations}`,
  ADD: `${card_reservations}.add`,
  EDIT: `${card_reservations}.edit`,
  IMPORT: `${card_reservations}.import`,
  DETAIL: `${card_reservations}.detail`,
  SELECT_ISSUANCE: {
    ROOT: `${card_reservations}.select`,
    BRANCH_SELECTION: `${card_reservations}.branch`
  }
};

// e Card Printing
const ecard_printing = "card.ecard.printing";
export const ECARD_PRINTING = {
  ROOT: `${ecard_printing}`,
  LIST: `${ecard_printing}`,
  REQUEST_TO_PRINTING: {
    ROOT: `${ecard_printing}.printing`,
    DELIVER_TO_CUSTOMER: `${ecard_printing}.customer`
  }
};

// Card Issuance
const card_issuance = "card.issuance";
export const CARD_ISSUANCE = {
  ROOT: `${card_issuance}`,
  LIST: `${card_issuance}.list`,
  REPORTING: `${card_issuance}.reporting`,
  DETAIL: {
    ROOT: `${card_issuance}.detail`,
    INFO: `${card_issuance}.detail.info`,
    CARD_LIST: {
      DETAIL: `card.list.detail`
    },
    DELIVERY_LIST: {
      DETAIL: `delivery.list.detail`,
      UPLOAD_RECEIPT: `upload.receipt`,
      CARD_LIST: `card.list.delivery.detail`
    },
    CUSTOMER_DELIVER: `customer.deliver`,
    BRANCH_DELIVER: `branch.deliver`
  }
};

// Card Lost
const card_lost = "card.lost";
export const CARD_LOST = {
  ROOT: `${card_lost}`,
  LIST: `${card_lost}.list`,
  REPORTING: `${card_lost}.reporting`,
  DETAIL: `${card_lost}.detail`,
  CREATE: `${card_lost}.create`
};

// Card Tracking
const card_tracking = "card.tracking";
export const CARD_TRACKING = {
  ROOT: `${card_tracking}`,
  BROWSE: `${card_tracking}.browse`,
  DETAIL: `${card_tracking}.detail`,
  REPORTING: `${card_tracking}.reporting`,
  LIST: `${card_tracking}.list`
};

// Master
const master = "master";
export const MASTER = {
  ROOT: `${master}`,
  LIST: `${master}.list`,
  REPORTING: `${master}.reporting`,
  BRANCH: {
    ROOT: `${master}.branches`,
    DETAIL: {
      ROOT: `${master}.branches.detail`,
      UPDATE: `${master}.branches.update`
    }
  },
  ZIPCODE: {
    ROOT: `${master}.zip`,
    CREATE: `${master}.zip.create`,
    IMPORT: `${master}.zip.import`,
    DETAIL: {
      ROOT: `${master}.zip.detail`,
      UPDATE: `${master}.zip.update`
    }
  },
  MRA: {
    ROOT: `${master}.mra`,
    CREATE: `${master}.mra.create`,
    DETAIL: {
      ROOT: `${master}.mra.detail`,
      UPDATE: `${master}.mra.update`
    }
  },
  MRO: {
    ROOT: `${master}.mro`,
    CREATE: `${master}.mro.create`,
    DETAIL: {
      ROOT: `${master}.mro.detail`,
      UPDATE: `${master}.mro.update`
    }
  },
  CARD_SOURCES: {
    ROOT: `${master}.cardsources`,
    DETAIL: `${master}.cardsources.detail`,
    CREATE: `${master}.cardsources.create`,
    UPDATE: `${master}.cardsources.update`
  },
  CARD_TYPES: {
    ROOT: `${master}.cardtypes`,
    DETAIL: `${master}.cardtypes.detail`,
    CREATE: `${master}.cardtypes.create`,
    UPDATE: `${master}.cardtypes.update`
  },
  REASON: {
    ROOT: `${master}.reason.update`,
    DETAIL: `${master}.reason.update.detail`,
    CREATE: `${master}.reason.update.create`,
    UPDATE: `${master}.reason.update.update`
  },
  REASON_FOR_LOSS: {
    ROOT: `${master}.reason.loss`,
    DETAIL: `${master}.reason.loss.detail`,
    CREATE: `${master}.reason.loss.create`,
    UPDATE: `${master}.reason.loss.update`,
    SELECT_CATEGORY: `${master}.reason.loss.select-category`
  },
  REASON_FOR_RETURN: {
    DELIVERY: {
      ROOT: `reason.return.delivery`,
      DETAIL: `reason.return.delivery.detail`,
      CREATE: `reason.return.delivery.create`,
      UPDATE: `reason.return.delivery.update`
    },
    VERIFICATION: {
      ROOT: `reason.return.verification`,
      DETAIL: `reason.return.verification.detail`,
      CREATE: `reason.return.verification.create`,
      UPDATE: `reason.return.verification.update`
    }
  },
  INSURANCE: {
    BROWSE: `${master}.insurance`,
    DETAIL: `${master}.insurance.detail`
  },
  REASON_FOR_EXTENSION: {
    BROWSE: `${master}.reason.extension`,
    DETAIL: `${master}.reason.extension.detail`,
    CREATE: `${master}.reason.extension.create`,
    UPDATE: `${master}.reason.extension.update`
  }
};

// Promo
const promo = "promo";
export const PROMO = {
  ROOT: `${promo}`,
  BROWSE: `${promo}.browse`,
  DETAIL: `${promo}.detail`,
  UPDATE: `${promo}.update`,
  UPDATE_RATES: `${promo}.update.rates`,
  NEW_PROMO: `${promo}.new`,
  REPORTING: `${promo}.reporting`,
  IMPORT: `${promo}.import`,
  UPDATE_BULK: `${promo}.update.bulk`
};

// Pre Order Agent
const pre_order_agent = "pre-order-agent";
export const PRE_ORDER_AGENT = {
  ROOT: `${pre_order_agent}`,
  BROWSE: `${pre_order_agent}.browse`,
  DETAIL: `${pre_order_agent}.detail`,
  UPDATE: `${pre_order_agent}.update`
};

// Product
const product = "product";
export const PRODUCT = {
  ROOT: `${product}`,
  BROWSE: `${product}.browse`,
  DETAIL: `${product}.detail`,
  UPDATE: `${product}.update`,
  GROUP: {
    BROWSE: `${product}.groups`,
    DETAIL: `${product}.groups.detail`,
    EDIT: `${product}.groups.edit`
  },
  INSURANCE: {
    BROWSE: `${product}.insurance`,
    DETAIL: `${product}.insurance.detail`,
    V2: {
      BROWSE: `${product}.insurance.v2`,
      DETAIL: `${product}.insurance.v2.detail`
    }
  }
};

// Store
const store = "store";
export const STORE = {
  ROOT: `${store}`,
  BROWSE: `${store}.browse`,
  DETAIL: {
    ROOT: `${store}.detail`,
    UPDATE: `${store}.update`
  },
  USER: {
    ROOT: `${store}.user`,
    DETAIL: `${store}.user.detail`,
    BROWSE: `${store}.user.browse`,
    CREATE: `${store}.user.create`,
    UPDATE: `${store}.user.update`
  },
  GROUP: {
    BROWSE: `${store}.store.groups`,
    DETAIL: `${store}.store.detail`
  },
  MAPPING_SF: {
    BROWSE: `${store}.mapping.sf`,
    IMPORT: `${store}.mapping.sf.import`
  },
  EXCLUSIVE_RATE: {
    BROWSE: `${store}.exclusive.rate`,
    UPDATE: `${store}.exclusive.rate.update`,
    IMPORT: `${store}.exclusive.rate.import`,
    DETAIL: `${store}.exclusive.rate.detail`
  },
  MARKETING_SCHEME: {
    UPDATE: `${store}.marketing-scheme.update`
  },
  NEW_STORE: `${store}.newstore`,
  REPORTING: `${store}.reporting`
};

// Company
const companies = "companies";
export const COMPANIES = {
  ROOT: `${companies}`,
  BROWSE: `${companies}.browse`,
  DETAIL: `${companies}.detail`
};

// Financial Schemes
const financial_scheme = "settings.finance.scheme";
export const FINANCIAL_SCHEME = {
  ROOT: `${financial_scheme}`,
  DETAIL: `${financial_scheme}.detail`,
  CREATE: `${financial_scheme}.create`,
  UPDATE: `${financial_scheme}.update`
};

// Banner
const master_banner = "settings.banner";
export const MASTER_BANNER = {
  ROOT: `${master_banner}`,
  DETAIL: `${master_banner}.detail`,
  CREATE: `${master_banner}.create`,
  UPDATE: `${master_banner}.update`
};

// App Setting Properties
const setting_properties = "settings.properties";
export const SETTING_PROPERTIES = {
  ROOT: `${setting_properties}`,
  DETAIL: `${setting_properties}.detail`,
  CREATE: `${setting_properties}.create`,
  UPDATE: `${setting_properties}.update`
};

// Master LOB settings
const master_lob = "settings.cms";
export const MASTER_LOB = {
  BROWSE: `${master_lob}.master-lob`,
  DETAIL: `${master_lob}.master-lob.detail`,
  CREATE: `${master_lob}.master-lob.create`,
  UPDATE: `${master_lob}.master-lob.update`
};

// Master Tiering Plafond
const tiering = "membership.master.tiering";
export const TIERING = {
  ROOT: `${tiering}`,
  DETAIL: `${tiering}.detail`,
  CREATE: `${tiering}.create`,
  UPDATE: `${tiering}.update`
};

// Master Token API
const master_token = "master.token.browse";
export const MASTER_TOKEN = {
  ROOT: `${master_token}`,
  DETAIL: `${master_token}.detail`,
  CREATE: `${master_token}.create`,
  UPDATE: `${master_token}.update`
};

// Branch
const branch = "branch.rate";
export const BRANCH = {
  ROOT: `${branch}`,
  CREATE: `${branch}.create`,
  IMPORT: `${branch}.import`,
  IMPORT_BULK: `${branch}.import-bulk`,
  DETAIL: {
    ROOT: `${branch}.detail`
  },
  RATE: {
    ROOT: `${branch}.rate`,
    CREATE: `${branch}.rate.create`,
    EXCLUSIVE_RATE: {
      ROOT: `${branch}.exclusive`,
      CREATE: `${branch}.exclusive.create`,
      UPDATE: `${branch}.exclusive.update`
    },
    DETAIL: {
      ROOT: `${branch}.rate.detail`,
      UPDATE: `${branch}.rate.update`
    }
  },
  FEE: {
    ROOT: `${branch}.fee`,
    CREATE: `${branch}.fee.create`,
    DETAIL: {
      ROOT: `${branch}.fee.detail`,
      UPDATE: `${branch}.fee.update`,
      EXCLUSIVE: {
        ROOT: `${branch}.fee.exclusive`,
        UPDATE: `${branch}.fee.exclusive.update`
      }
    }
  }
};

// Membership
const membership = "membership";
export const MEMBERSHIP = {
  ROOT: `${membership}`,
  BROWSE: `${membership}.browse`,
  CREATE: `${membership}.create`,
  UPDATE: `${membership}.update`,
  DETAIL: {
    ROOT: `${membership}.detail`,
    LIST: `${membership}.detail.list`,
    RISK_CREATE: `${membership}.detail.risk.create`,
    RISK_UPDATE: `${membership}.detail.risk.update`,
    RISK_DETAIL: `${membership}.detail.risk.detail`,
    DOCUMENT_UPDATE: `${membership}.detail.document.update`,
    ESCROW_DETAIL: `${membership}.detail.escrow`,
    ESCROW_UPDATE: `${membership}.detail.escrow.update`,
    ESCROW_BALANCE_TRACKING: `${membership}.detail.escrow.balance`
  },
  REPORTING: `${membership}.reporting`,
  IMPORT: {
    ROOT: `${membership}.import`,
    LIST: `${membership}.import.list`,
    CREATE: `${membership}.import.create`,
    UPDATE: `${membership}.import.update`,
    DETAIL: `${membership}.import.detail`,
    EMPLOYEE: {
      ROOT: `${membership}.import.employee`,
      LIST: `${membership}.import.employee.list`,
      CREATE: `${membership}.import.employee.create`,
      UPDATE: `${membership}.import.employee.update`,
      DETAIL: `${membership}.import.employee.detail`
    }
  },
  RISK_PROFILE: {
    ROOT: `${membership}.riskprofiles`
  },
  SETUP_DATABASE: {
    ROOT: `${membership}.setup.database`,
    DETAIL: `${membership}.setup.database.detail`,
    UPDATE: `${membership}.setup.database.update`,
    CREATE: `${membership}.newdb`
  },
  NATIONAL: {
    ROOT: `${membership}.browse.NM`,
    DETAIL: `${membership}.detail.NM`
  },
  FAQ: {
    ROOT: `${membership}.faq.editor`
  },
  SILO: {
    ROOT: `${membership}.newsilo`,
    DETAIL: `${membership}.newsilo.detail`,
    UPDATE: `${membership}.newsilo.update`,
    CREATE: `${membership}.newsilo.create`
  },
  EXTERNAL_SOURCE: {
    ROOT: `${membership}.token.management`,
    DETAIL: `${membership}.token.management.detail`,
    UPDATE: `${membership}.token.management.update`,
    CREATE: `${membership}.token.management.create`
  },
  REPLACE_CARD_NUMBER: {
    ROOT: `${membership}.replace.card.number`
  },
  GROUP: {
    ROOT: `${membership}.group`,
    CREATE: `${membership}.group.create`,
    UPDATE: `${membership}.group.update`,
    DETAIL: `${membership}.group.detail`,
    IMPORT: `${membership}.group.import`,
    MAPPING: {
      CREATE: `${membership}.group.mapping.create`,
      UPDATE: `${membership}.group.mapping.update`
    }
  },
  BLACKLIST_PHONE_NO: {
    ROOT: `${membership}.blacklist.phoneno`,
    CREATE: `${membership}.blacklist.phoneno.create`,
    UPDATE: `${membership}.blacklist.phoneno.update`,
    DETAIL: `${membership}.blacklist.phoneno.detail`,
    IMPORT_BULK: `${membership}.blacklist.phoneno.import`
  },
  PHOTOS_SCREENING: {
    ROOT: `${membership}.photos-screening`
  },
  EMPLOYEE: {
    ROOT: `${membership}.employee`,
    DETAIL: `${membership}.employee.detail`
  }
};

const qanun_branch = "qanun.branch";
export const QANUN_BRANCH = {
  ROOT: `${qanun_branch}`,
  IMPORT: `${qanun_branch}.import`,
  DETAIL: `${qanun_branch}.detail`,
  CREATE: `${qanun_branch}.create`,
  UPDATE: `${qanun_branch}.update`
};

const notification_error = "settings.notification";
export const NOTIFICATION_ERROR = {
  ROOT: `${notification_error}`,
  CREATE: `${notification_error}.create`,
  UPDATE: `${notification_error}.update`,
  DETAIL: {
    ROOT: `${notification_error}.detail`
  }
};

const member_management = "settings.member.management";
export const MEMBER_MANAGEMENT = {
  ROOT: `${member_management}`,
  CREATE: `${member_management}.create`,
  UPDATE: `${member_management}.update`,
  DETAIL: {
    ROOT: `${member_management}.detail`
  }
};

const card_reset_reason = "membership.cardreset";
export const CARD_RESET_REASON = {
  ROOT: `${card_reset_reason}`,
  CREATE: `${card_reset_reason}.create`,
  UPDATE: `${card_reset_reason}.update`,
  DETAIL: {
    ROOT: `${card_reset_reason}.detail`
  }
};

// Program Type
const program_type = "program-type";
export const PROGRAM_TYPE = {
  ROOT: `${program_type}`,
  CREATE: `${program_type}.create`,
  UPDATE: `${program_type}.update`,
  DETAIL: `${program_type}.detail`
};

// Roles
const orders = "log.tracking.order";
export const ORDERS = {
  ROOT: `${orders}`
};

// Page Not Found
export const ERROR_PAGE = {
  PAGE404_CONTENT: "page404.content",
  PAGE503_CONTENT: "page503.content",
  PAGE404: "page404",
  PAGE500: "page500",
  PAGE503: "page503"
};

// NMC
const nmc = "nmc";
export const NMC = {
  INSURANCE: {
    BROWSE: `${nmc}.insurance.browse`,
    CREATE: `${nmc}.insurance.browse.create`,
    UPDATE: `${nmc}.insurance.browse.update`,
    DETAIL: `${nmc}.insurance.browse.detail`
  },
  BRANCH: {
    BROWSE: `${nmc}.master.branch`,
    CREATE: `${nmc}.master.branch.create`,
    UPDATE: `${nmc}.master.branch.update`,
    DETAIL: `${nmc}.master.branch.detail`,
    IMPORT: `${nmc}.master.branch.import`,
    IMPORT_BULK: `${nmc}.master.branch.import-bulk`,
    FEE: {
      ROOT: `${nmc}.master.branch.fee.root`,
      CREATE: `${nmc}.master.branch.fee.create`,
      DETAIL: `${nmc}.master.branch.fee.detail`,
      UPDATE: `${nmc}.master.branch.fee.update`,
      EXCLUSIVE: {
        ROOT: `${nmc}.master.branch.fee.exclusive.root`,
        CREATE: `${nmc}.master.branch.fee.exclusive.create`,
        UPDATE: `${nmc}.master.branch.fee.exclusive.update`
      }
    },
    RATE: {
      ROOT: `${nmc}.master.branch.rate.root`,
      CREATE: `${nmc}.master.branch.rate.create`,
      DETAIL: `${nmc}.master.branch.rate.detail`,
      UPDATE: `${nmc}.master.branch.rate.update`
    },
    EXCLUSIVE_RATE: {
      CREATE: `${nmc}.master.branch.exclusive-rate.create`,
      UPDATE: `${nmc}.master.branch.exclusive-rate.update`
    }
  },
  PROMO_FEE: {
    BROWSE: `${nmc}.master.promo-fee`,
    RESET: `${nmc}.master.promo-fee.reset`,
    IMPORT_BULK: `${nmc}.master.promo-fee.import-bulk`
  },
  QANUN_BRANCH: {
    ROOT: `${nmc}.qanun.branch`,
    IMPORT: `${nmc}.qanun.branch.import`,
    DETAIL: `${nmc}.qanun.branch.detail`,
    CREATE: `${nmc}.qanun.branch.create`,
    UPDATE: `${nmc}.qanun.branch.update`
  },
  DEALER: {
    ROOT: `${nmc}`,
    BROWSE: `${nmc}.dealer.browse`,
    CREATE: `${nmc}.dealer.browse.create`,
    UPDATE: `${nmc}.dealer.browse.update`,
    DETAIL: `${nmc}.dealer.browse.detail`,
    MARKETING_SCHEME: {
      UPDATE: `${nmc}.dealer.marketing-scheme.update`
    }
  },
  NEW_DEALER: {
    BROWSE: `${nmc}.dealer.newdealer`
  },
  DEALER_MAPPING_SF: {
    ROOT: `${nmc}`,
    BROWSE: `${nmc}.dealer.mapping.sf`,
    CREATE: `${nmc}.dealer.mapping.sf.create`,
    UPDATE: `${nmc}.dealer.mapping.sf.update`,
    DETAIL: `${nmc}.dealer.mapping.sf.detail`,
    IMPORT: `${nmc}.dealer.mapping.sf.import`
  },
  EXCLUSIVE_DEALER_ADMIN: {
    ROOT: `${nmc}`,
    BROWSE: `${nmc}.dealer.exclusive.dealer.admin`,
    DETAIL: `${nmc}.dealer.exclusive.dealer.admin.detail`,
    CREATE: `${nmc}.dealer.exclusive.dealer.admin.create`,
    UPDATE: `${nmc}.dealer.exclusive.dealer.admin.update`,
    IMPORT: `${nmc}.dealer.exclusive.dealer.admin.import`
  },
  EXCLUSIVE_DEALER_RATE: {
    ROOT: `${nmc}`,
    BROWSE: `${nmc}.dealer.exclusive.dealer.rate`,
    DETAIL: `${nmc}.dealer.exclusive.dealer.rate.detail`,
    CREATE: `${nmc}.dealer.exclusive.dealer.rate.create`,
    UPDATE: `${nmc}.dealer.exclusive.dealer.rate.update`,
    IMPORT: `${nmc}.dealer.exclusive.dealer.rate.import`
  },
  PROMO: {
    BROWSE: `${nmc}.promo.browse`,
    UPDATE: `${nmc}.promo.browse.update`,
    DETAIL: `${nmc}.promo.browse.detail`,
    IMPORT: `${nmc}.promo.browse.import`,
    UPDATE_RATE: `${nmc}.promo.browse.update_rate`,
    NEW: `${nmc}.promo.new`
  },
  PRODUCT: {
    BROWSE: `${nmc}.product.browse`,
    DETAIL: `${nmc}.product.detail`,
    CREATE: `${nmc}.product.create`,
    UPDATE: `${nmc}.product.update`,
    INSURANCE: {
      ROOT: `${nmc}.product.insurance`,
      DETAIL: `${nmc}.product.insurance.detail`,
      UPDATE: `${nmc}.product.insurance.update`
    },
    GROUP: {
      BROWSE: `${nmc}.product.groups`,
      DETAIL: `${nmc}.product.groups.detail`,
      UPDATE: `${nmc}.product.groups.edit`
    }
  },
  FINANCIAL_SCHEME: {
    BROWSE: `${nmc}.financial.scheme.browse`,
    DETAIL: `${nmc}.financial.scheme.detail`,
    CREATE: `${nmc}.financial.scheme.create`,
    UPDATE: `${nmc}.financial.scheme.update`
  },
  PO_STATUS: {
    ROOT: `${nmc}.postatus`,
    BROWSE: `${nmc}.postatus.browse`,
    DETAIL: `${nmc}.postatus.detail`,
    SALES: `${nmc}.postatus.sales`,
    DETAIL_SALES: `${nmc}.postatus.sales-detail`,
    PHOTOS_SCREENING: `${nmc}.postatus.photos-screening`,
    ARCHIVE: {
      BROWSE: `${nmc}.postatus.archive`,
      DETAIL: `${nmc}.postatus.archive.detail`
    }
  }
};

// UFI
const ufi = "ufi";
export const UFI = {
  BRANCH: {
    BROWSE: `${ufi}.master.branch`,
    CREATE: `${ufi}.master.branch.create`,
    UPDATE: `${ufi}.master.branch.update`,
    DETAIL: `${ufi}.master.branch.detail`,
    IMPORT: `${ufi}.master.branch.import`,
    IMPORT_BULK: `${ufi}.master.branch.import-bulk`,
    FEE: {
      ROOT: `${ufi}.master.branch.fee.root`,
      CREATE: `${ufi}.master.branch.fee.create`,
      DETAIL: `${ufi}.master.branch.fee.detail`,
      UPDATE: `${ufi}.master.branch.fee.update`,
      EXCLUSIVE: {
        ROOT: `${ufi}.master.branch.fee.exclusive.root`,
        CREATE: `${ufi}.master.branch.fee.exclusive.create`,
        UPDATE: `${ufi}.master.branch.fee.exclusive.update`
      }
    },
    RATE: {
      ROOT: `${ufi}.master.branch.rate.root`,
      CREATE: `${ufi}.master.branch.rate.create`,
      DETAIL: `${ufi}.master.branch.rate.detail`,
      UPDATE: `${ufi}.master.branch.rate.update`
    },
    EXCLUSIVE_RATE: {
      CREATE: `${ufi}.master.branch.exclusive-rate.create`,
      UPDATE: `${ufi}.master.branch.exclusive-rate.update`
    }
  },
  PROMO: {
    BROWSE: `${ufi}.promo.browse`,
    UPDATE: `${ufi}.promo.update`,
    DETAIL: `${ufi}.promo.detail`,
    IMPORT: `${ufi}.promo.import`,
    UPDATE_RATE: `${ufi}.promo.update_rate`,
    NEW: `${ufi}.promo.new`,
    UPDATE_BULK: `${ufi}.update.bulk`
  },
  KIOSK: {
    BROWSE: `${ufi}.kios.browse`,
    UPDATE: `${ufi}.kios.update`,
    DETAIL: `${ufi}.kios.detail`
  },
  DEALER: {
    ROOT: `${ufi}`,
    BROWSE: `${ufi}.dealer.browse`,
    CREATE: `${ufi}.dealer.browse.create`,
    UPDATE: `${ufi}.dealer.browse.update`,
    DETAIL: `${ufi}.dealer.browse.detail`
  },
  NEW_DEALER: {
    BROWSE: `${ufi}.dealer.newdealer`
  },
  OBJECT: {
    BROWSE: `${ufi}.object.browse`,
    DETAIL: `${ufi}.object.detail`,
    CREATE: `${ufi}.object.create`,
    UPDATE: `${ufi}.object.update`,
    INSURANCE: {
      ROOT: `${ufi}.object.insurance`,
      DETAIL: `${ufi}.object.insurance.detail`,
      UPDATE: `${ufi}.object.insurance.update`
    },
    GROUP: {
      BROWSE: `${ufi}.object.groups`,
      DETAIL: `${ufi}.object.groups.detail`,
      UPDATE: `${ufi}.object.groups.edit`
    }
  },
  FINANCIAL_SCHEME: {
    BROWSE: `${ufi}.financial.scheme.browse`,
    DETAIL: `${ufi}.financial.scheme.detail`,
    CREATE: `${ufi}.financial.scheme.create`,
    UPDATE: `${ufi}.financial.scheme.update`
  }
};

const debug = "debug";
export const DEBUG = {
  ROOT: `${debug}`,
  AUDIT_TRAIL: {
    BROWSE: `${debug}.cms.audit`,
    DETAIL: `${debug}.cms.audit.detail`
  },
  LOG: {
    BROWSE: `${debug}.cms.log`,
    DETAIL: {
      TRANSACTION_LOG: `${debug}.cms.log.transaction`,
      TRANSACTION_ERROR_LOG: `${debug}.cms.log.error`,
      OTP_LOG: `${debug}.cms.log.otp`,
      ORDERFULL_LOG: `${debug}.cms.log.orderfull`,
      SCHEDULER_LOG: `${debug}.cms.log.scheduler`,
      BALANCE_TRACKING_LOG: `${debug}.cms.log.balance`,
      REJECT_LOG: `${debug}.cms.log.reject`
    }
  },
  UPDATE_SMS_CONTENT: {
    BROWSE: `${debug}.sms.content.browse`,
    UPDATE: `${debug}.sms.content.update`
  }
};

// Region
const regions = "regions";
export const REGIONS = {
  ROOT: `${regions}`,
  BROWSE: `${regions}.browse`,
  DETAIL: `${regions}.detail`
};

// Menu management
const menu_management = "settings.menu.management";
export const MENU_MANAGEMENT = {
  ROOT: `${menu_management}`,
  CREATE: `${menu_management}.create`,
  UPDATE: `${menu_management}.update`,
  DETAIL: {
    ROOT: `${menu_management}.detail`
  },
  SUB_MENU: {
    DETAIL: `${menu_management}.submenu.detail`,
    CREATE: `${menu_management}.submenu.create`,
    UPDATE: `${menu_management}.submenu.update`
  }
};

// Costumer Confirmation Management
const customer_confirmation = "customer-confirmation";
export const CUSTOMER_CONFIRMATION_MANAGEMENT = {
  BROWSE: `${customer_confirmation}.management`,
  DETAIL: `${customer_confirmation}.management.detail`,
  UPDATE: `${customer_confirmation}.management.update`,
  CREATE: `${customer_confirmation}.management.create`,
  DETAIL_HISTORY: `${customer_confirmation}.management.detail.history`
};

// Download Management
const download_management = "download-management";
export const DOWNLOAD_MANAGEMENT = {
  ROOT: `${download_management}`,
  DETAIL: `${download_management}.detail`
};

// Customer Satisfaction Survey
const customer_survey = "customer-survey";
export const CUSTOMER_SURVEY = {
  ROOT: `${customer_survey}`,
  BROWSE: `${customer_survey}.browse`,
  DETAIL: `${customer_survey}.detail`
};

// Mediator

const mediator = "mediator";
export const MEDIATOR = {
  ROOT: `${mediator}`,
  SAO: {
    BROWSE: `${mediator}.sao`
  },
  MEDIATOR: {
    BROWSE: `${mediator}.browse`
  }
};

const familyFinancing = "family-financing";
export const FAMILY_FINANCING = {
  ROOT: `${familyFinancing}`,
  BROWSE: `${familyFinancing}.browse`,
  DETAIL: `${familyFinancing}.detail`,
  CREATE: `${familyFinancing}.create`,
  UPDATE: `${familyFinancing}.update`
};
